module.exports = __webpack_public_path__ + "static/BT-mobile-7-9cdf4882f7a76a814bf67c001d72f7bb.jpg";